<template>
<div
  class="Lightbox"
  id="RuleBox">
  <div
    @click="close"
    class="LightboxOverlay"></div>
  <div class="LightboxWrap">
    <div class="Content">
      <div class="Titlebar">
        <h3>選擇此商品</h3>
        <div class="BtnClose">
          <a @click="close" class="Close">Close</a>
        </div>
      </div>
      <div
        class="DetailBox"
        :style="calacScrollHeight">
        <div
          v-if="showSpecBox"
          class="DetailRow">
          <div class="LabelName">商品規格</div>
          <div class="StyleList">
            <a @click="changeNowSpec(item.id, index)" v-for="(item, index) of info.measure" :key="index" :class="{Activity: nowSelectedSpec === item.id, NoStore: item.sold_out}" :title="item.spec">{{ item.spec }}</a>
          </div>
        </div>
        <div class="Flex">
          <div class="LabelName">數量</div>
          <div class="Quantity">
            <button @click="minus()" class="IconMin"></button>
            <input type="text" :value="cartBuyQuantity" class="QuantityNum" readonly="true" />
            <button @click="plus()" class="IconPlus"></button>
          </div>
        </div>

        <buyadditional
          v-if="showAdditional"
          :items="info.additional"
          v-on:sendAdditional="getAdditional" />
      </div>
      <div class="ButtonBar">
        <a @click="goShop()" title="選購" class="Btn">
          <i class="IconCar"></i>選購
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import buyadditional from "./buyadditional";
export default {
  name: "buyitem",
  data() {
    return {
      cartData: [],
      info: {},
      showAdditional: false,
      showSpecBox: false,
      nowSelectedSpec: null,
      nowSelectedSpecIdx: 0,
      nowSelectedSpecName: "",
      cartBuyQuantity: 1,
      cartAdditional: [],
      lightboxWrapTop: 0,
    };
  },
  props: {
    pid: {
      type: Number,
      required: true,
    },
    cid: {
      type: Number,
      required: true,
    },
    defaultQty: {
      type: Number,
      default: () => 1
    }
  },
  updated() {},
  mounted() {},
  computed: {
    calacScrollHeight() {
      return {
        "max-height": this.isMobile ? window.innerHeight - 182 + "px" : "500px",
      };
    },
  },
  created() {
    const cacheName = `baseshop_product_detail_${this.pid}_${this.cid}`
    const cache = this.storage.get(cacheName, true)
    if (cache) {
      this.info = cache
      this.parseProductDetail()
    } else {
      this.axios
        .get(`api/product/${this.pid}/detail?cid=${this.cid}`)
        .then((res) => {
          const data = res.data;
          if (data.status === 1 && data.data.length > 0) {
            this.info = data.data[0];
            this.parseProductDetail()
            this.storage.set(cacheName, data.data[0], this.configs.webCacheExpireTime, true)
          }
        });
    }
    this.cartBuyQuantity = this.defaultQty
  },
  methods: {
    parseProductDetail() {
      for (let i in this.info.measure) {
        if (!this.info.measure[i].sold_out) {
          this.nowSelectedSpec = this.info.measure[i].id;
          this.nowSelectedSpecIdx = parseInt(i);
          this.nowSelectedSpecName = this.info.measure[i].spec;
          break;
        }
      }
      if (this.info.measure.length > 1) {
        this.showSpecBox = true;
      }
      if (this.info.additional && this.info.additional.length > 0) {
        this.showAdditional = true;
        this.$emit('hasAdditional', this.info, this.cid)
      }

      this.$emit("setCartType", this.info.cart_type);
    },
    changeNowSpec(id, idx) {
      if (!this.info.measure[idx].sold_out) {
        this.nowSelectedSpecIdx = idx;
        this.cartBuyQuantity = 1;
        this.nowSelectedSpec = id;
        this.nowSelectedSpecName = this.info.measure[idx].spec;
      }
    },
    close() {
      this.$emit("closeBuyItem");
    },
    minus() {
      this.cartBuyQuantity =
        this.cartBuyQuantity === 1 ? 1 : (this.cartBuyQuantity -= 1);
    },
    plus() {
      const purchase_qty = this.info.measure[this.nowSelectedSpecIdx]
        .purchase_qty;
      this.cartBuyQuantity =
        this.cartBuyQuantity < purchase_qty ?
        (this.cartBuyQuantity += 1) :
        purchase_qty;
    },
    goShop() {
      // clean all
      this.cartData = [];
      const o = this.info;

      let channelId = '';
      const chaId = document.cookie.match(/CHANNEL_ID0=([^;]+)/i);
      if (chaId && chaId[1] && chaId[1] !== 'fetmc_appbonus') {
        channelId = chaId[1];
      }

      // 主商品
      this.cartData.push({
        carttype: o.cart_type,
        ptype: 0,
        mid: o.mid,
        pid: o.pid,
        sid: o.sid,
        cid: o.cid,
        qty: +this.cartBuyQuantity,
        specid: +this.nowSelectedSpec,
        payformRadio: "CASH",
        promoid: "",
        partialPoint: +null,
        partialPrice: +null,
        exchangePoint: +null,
        name: o.name,
        price: +o.special_price,
        specname: this.nowSelectedSpecName,
        imgpath: o.sample_images[0],
        channelId3: channelId
        // imgpath: o.sample_images && o.sample_images.length > 0 ? [0] : '',
      });

      // 贈品
      if (o.gift && o.gift.length > 0) {
        o.gift.forEach((g) => {
          this.cartData.push({
            carttype: o.cart_type,
            ptype: 4,
            mid: o.mid,
            sid: o.sid,
            cid: o.cid,
            ppid: o.pid,
            pid: g.aid,
            qty: g.max_qty > g.with_main_product_qty * this.cartBuyQuantity ?
              g.with_main_product_qty * this.cartBuyQuantity : g.max_qty,
            pqty: this.cartBuyQuantity,
            specid: this.nowSelectedSpec,
            pspecid: this.nowSelectedSpec,
            payformRadio: "CASH",
            channelId3: channelId
          });
        });
      }

      // 加價購
      if (this.cartAdditional && this.cartAdditional.length > 0) {
        this.cartAdditional = this.cartAdditional.filter(
          (item) => item.qty > 0
        );
        this.cartAdditional.forEach((g) => {
          this.cartData.push({
            carttype: o.cart_type,
            ptype: 3,
            mid: o.mid,
            sid: o.sid,
            cid: o.cid,
            ppid: o.pid,
            pid: g.aid,
            qty: g.qty,
            imgpath: g.imageUrl,
            pqty: this.cartBuyQuantity,
            specid: this.nowSelectedSpec,
            pspecid: this.nowSelectedSpec,
            payformRadio: "CASH",
            channelId3: channelId
          });
        });
      }
      this.$emit("addToCart", this.cartData);
    },
    getAdditional(data) {
      this.cartAdditional = data;
    },
  },
  components: {
    buyadditional,
  },
};
</script>

<style lang="scss" scoped>
#RuleBox {
  .LightboxWrap {
    max-width: 460px;
    height: auto;
    max-height: 690px;
    min-height: 300px;
  }

  .ButtonBar {
    margin: 0;
    position: absolute;
    left: 0;
    right: 0;
    padding-top: 3%;
    border-top: 1px solid #e0e0e0;
    padding: 2%;
    bottom: 0;
    background-color: #fff;
    border-radius: 0 0 10px 10px;
    cursor: pointer;
  }
}

.StyleList {
  a {
    display: inline-block;
    padding: 1% 3%;
    background-color: #f4f4f4;
    color: #adadad;
    margin-right: 5px;
    border-radius: 8px;
    margin-bottom: 5px;
  }

  a.Activity {
    background-color: #f34f59;
    color: #fff;
  }

  a.NoStore {
    background-color: #f4f4f4;
    color: #e0e0e0;
    cursor: default;
  }
}

@media (max-width: 768px) {
  #RuleBox {
    .LightboxWrap {
      bottom: 0;
      position: inherit;
      width: 100%;
      max-width: 100%;
      border-radius: inherit;
      max-height: 90vh;
    }
  }
}
</style>
